import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-apartment`
let baseUrl3 = `${httpUrl.host}/gy-apartment`

let api = {
  // 月报警数
  getMonthAlarmRecord: `${baseUrl}/fcsOverview/getMonthAlarmRecord`,

  // 设备统计
  getDeviceStatus: `${baseUrl}/fcsOverview/getDeviceStatus`,

  // 设备统计
  getFcsDeviceStatistics: `${baseUrl}/fcsOverview/getFcsDeviceStatistics`,

  // 报警统计
  getFcsStatistics: `${baseUrl}/fcsOverview/getFcsStatistics`,

  // 添加网关设备
  addGatewayDevice: `${baseUrl}/deviceGateway/add`,

  // 修改网关设备
  updateGatewayDevice: `${baseUrl}/deviceGateway/update`,

  // 删除网关设备
  deleteGatewayDevice: `${baseUrl}/deviceGateway/delete`,

  // 网关设备详情
  getGatewayDeviceByCode: `${baseUrl}/deviceGateway/getByCode`,

  // 网关设备分页
  getGatewayDevicePage: `${baseUrl}/deviceGateway/getPage`,

  // 网关设备列表
  getGatewayDeviceList: `${baseUrl}/deviceGateway/getList`,

  // 添加液位液压设备
  addHydraulicDevice: `${baseUrl}/fcsWaterDevice/add`,

  // 修改液位液压设备
  updateHydraulicDevice: `${baseUrl}/fcsWaterDevice/update`,

  // 删除液位液压设备
  deleteHydraulicDevice: `${baseUrl}/fcsWaterDevice/delete`,

  // 液位液压设备详情
  getHydraulicDeviceByCode: `${baseUrl}/fcsWaterDevice/getByCode`,

  // 液位液压设备分页
  getHydraulicDevicePage: `${baseUrl}/fcsWaterDevice/getPage`,

  // 添加烟感设备
  addFireSmokeDevice: `${baseUrl}/fireSmokeDevice/add`,

  // 修改烟感设备
  updateFireSmokeDevice: `${baseUrl}/fireSmokeDevice/update`,

  // 删除烟感设备
  deleteFireSmokeDevice: `${baseUrl}/fireSmokeDevice/delete`,

  // 烟感设备详情
  getFireSmokeDeviceByCode: `${baseUrl}/fireSmokeDevice/getByCode`,

  // 液位液压设备分页
  getFireSmokeDevicePage: `${baseUrl}/fireSmokeDevice/getPage`,

  // 添加用传设备
  addTransmissionDevice: `${baseUrl}/fcsUserTransforDevice/add`,

  // 修改用传设备
  updateTransmissionDevice: `${baseUrl}/fcsUserTransforDevice/update`,

  // 删除用传设备
  deleteTransmissionDevice: `${baseUrl}/fcsUserTransforDevice/delete`,

  // 用传设备详情
  getTransmissionDeviceByCode: `${baseUrl}/fcsUserTransforDevice/getByCode`,

  // 用传设备分页
  getTransmissionDevicePage: `${baseUrl}/fcsUserTransforDevice/getPage`,

  // 添加点位设备
  addFcsPointDevice: `${baseUrl}/fcsPointDevice/add`,

  // 修改点位设备
  updateFcsPointDevice: `${baseUrl}/fcsPointDevice/update`,

  // 删除点位设备
  deleteFcsPointDevice: `${baseUrl}/fcsPointDevice/delete`,

  // 点位设备详情
  getFcsPointDeviceByCode: `${baseUrl}/fcsPointDevice/getByCode`,

  // 点位设备分页
  getFcsPointDevicePage: `${baseUrl}/fcsPointDevice/getPage`,

  // 导入点位设备
  importFcsPointDevicePage: `${baseUrl}/fcsPointDevice/import`,

  // 导出点位设备
  exportFcsPointDevicePage: `${baseUrl}/fcsPointDevice/export`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  // 获取人员列表
  getResponsiblePerson: `${baseUrl85}/person/getResponsiblePersonList`,

  // 获取门禁列表
  getAccessDeviceList: `${baseUrl2}/accessDevice/getList`,

  // 获取电梯列表
  getLiftDeviceList: `${baseUrl3}/liftDevice/getList`,

  // 设备状态日志分页
  getFireDeviceStatusPage: `${baseUrl}/fireDeviceStatus/getPage`,

  // 设备报警记录分页
  getFcsUserTransferRecordPage: `${baseUrl}/fcsUserTransforRecord/getPage`,

  // 设备报警记录分页
  getFcsAlarmRecordPage: `${baseUrl}/fcsAlarmRecord/getPage`,

  // 设备报警记录分页
  getAlarmRecordByDevice: `${baseUrl}/fcsAlarmRecord/getAlarmRecordByDevice`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/FireControl.js